// Cinturón y tirantes (2026-09-11): Director Técnico Q.F./B.F. no debería
// llegar nunca a Dashboard/Pacientes/Agenda/Historias/Reportes (nav ya
// oculto para este rol, ver TopNav.tsx y el login/registro que lo manda
// directo a /farmacia) — esto cubre el caso de un link/bookmark viejo. Deja
// pasar mientras el rol carga (evita un parpadeo en blanco para el 99% de
// usuarios que no son Director Técnico) y solo redirige una vez resuelto.
import type { JSX } from 'react';
import { Navigate } from 'react-router';
import { esDirectorTecnicoFarmacia, useRolDelPracticante } from '../lib/useRolDelPracticante';

export function RequiereNoFarmacia({ children }: { children: JSX.Element }): JSX.Element {
  const estado = useRolDelPracticante();
  if (esDirectorTecnicoFarmacia(estado)) return <Navigate to="/farmacia" replace />;
  return children;
}
